<template>
	<div class="flex" :class="[columnsOrder, columnGap]">
		<div
			:class="[
				firstColumnClass,
				firstColumnWidth,
				hasPaddingFirstColumn ? 'contained-section' : '',
			]"
		>
			<slot name="first"></slot>
		</div>
		<div v-if="showBorder">
			<hr class="h-full w-px border-l" />
		</div>
		<div
			v-if="$slots.second"
			:class="[
				secondColumnClass,
				secondColumnWidth,
				hasPaddingSecondColumn ? 'contained-section' : '',
			]"
		>
			<slot name="second"></slot>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	columnsOrder: {
		type: String,
		default: 'flex-col lg:flex-row',
		required: false,
	},
	firstColumnWidth: {
		type: String,
		default: 'w-full lg:w-1/2',
		required: false,
	},
	secondColumnWidth: {
		type: String,
		default: 'w-full lg:w-1/2',
		required: false,
	},
	firstColumnClass: {
		type: String,
		default: '',
		required: false,
	},
	secondColumnClass: {
		type: String,
		default: '',
		required: false,
	},
	hasPaddingFirstColumn: {
		type: Boolean,
		default: false,
		required: false,
	},
	hasPaddingSecondColumn: {
		type: Boolean,
		default: false,
		required: false,
	},
	columnGap: {
		type: String,
		default: '',
		required: false,
	},
	showBorder: {
		type: Boolean,
		default: false,
		required: false,
	},
})
</script>
